import React, { useState } from 'react'
import { ResponsiveLine } from '@nivo/line';
import LoadingScreen from '../../LoadingScreen';

const LineChart = ({trend}) => {
    const [loading,setLoading] = useState(false);

    const generateWholeNumbersYAxis = (data) => {
      const maxTicketSales = Math.max(...data.map((d) => d.y));
      return Array.from({ length: maxTicketSales + 1 }, (_, index) => index);
    };



  return (
    <div >
      {loading ? <LoadingScreen /> : 
       (<div style={{ height: '25vh', width:"100%" }}>
        <h4 style={{marginTop:"-1em"}}>Today's ticket sales trend</h4>
        <ResponsiveLine
        data={trend}
        margin={{ top: 15, right: 40, bottom: 60, left: 60 }}
        xScale={{ type: 'point' }}
        yScale={{ type: 'linear', min: 'auto', max: 'auto', stacked: true, reverse: false }}
        yFormat=" >-.2f"
        axisTop={null}
        axisRight={null}
        axisBottom={{
            orient: 'bottom',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: -45,
            tickValues:"every 2 hours",
            legend: 'Hour',
            legendOffset: 46,
            legendPosition: 'middle'
        }}
        axisLeft={{
            orient: 'left',
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'Tickets Sold',
            legendOffset: -40,
            legendPosition: 'middle',
            tickValues: generateWholeNumbersYAxis(trend[0].data),
        }}
        colors={["#6563FF"]}
        pointSize={10}
        pointColor={{ theme: 'background' }}
        pointBorderWidth={2}
        pointBorderColor={{ from: 'serieColor' }}
        pointLabelYOffset={-12}
        useMesh={true}
        
    />
    </div>)}
    </div>
  )
}

export default LineChart